<div *ngIf="orderReady">
    <!-- Header -->
    <div class="modal-header">
        <div class="title">
            <h2 class="modal-title">Informations du chantier</h2>
            <div class="info-client modal-title">
                <div>
                    <h4 style="text-transform: uppercase"><span>
                            Numéro intervention: {{this.ficheChantierInfos.intervention_number}}</span></h4>
                    <a href="{{this.ficheChantierInfos.pdf}}" *ngIf="this.ficheChantierInfos.pdf"><button
                            class="btn btn-primary">Voir Fiche chantier
                            PDF</button></a>
                </div>
            </div>
        </div>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <!-- Body -->
    <div class="modal-body d-flex flex-column ">
        <div class="info-client-details">
            <div class="d-flex flex-row">
                <!-- Delivery address -->
                <div class="d-flex flex-column flex-50">
                    <h5>Informations du chantier</h5>
                    <div class="info-block">
                        <i class="fa fa-sticky-note-o" aria-hidden="true"></i>
                        <div>
                            <p>{{this.ficheChantierInfos.display_name}}</p>
                        </div>
                    </div>
                    <div class="info-block">
                        <i class="fa fa-home" aria-hidden="true"></i>
                        <div>
                            <p>{{this.ficheChantierInfos.street}} {{this.ficheChantierInfos.cp_city}}
                                {{this.ficheChantierInfos.country}} ({{this.ficheChantierInfos.country_department}})</p>
                        </div>
                    </div>
                    <div class="info-block">
                        <i class="fa fa-edit" aria-hidden="true"></i>
                        <p>Chantier créé le <span class="text-bold">{{this.ficheChantierInfos.created_at |
                                date:'longDate'}}</span>
                        </p>
                    </div>
                    <div class="info-block" *ngIf="this.ficheChantierInfos.updated_at">
                        <i class="fa fa-edit" aria-hidden="true"></i>
                        <p>Chantier modifié le <span class="text-bold">{{this.ficheChantierInfos.updated_at |
                                date:'longDate'}}</span>
                        </p>
                    </div>
                </div>
                <div class="d-flex flex-column flex-50">
                    <h5>A propos du chantier</h5>
                    <p>Observations : <span class="text-bold">{{this.ficheChantierInfos.observations}}</span>
                    </p>
                    <p>Type de chantier : <span class="text-bold">{{this.ficheChantierInfos.environment_choice}}</span>
                    </p>
                </div>

            </div>
            <div class="d-flex flex-row">
                <!-- Contact -->
                <div class="d-flex flex-column flex-50">
                    <h5>Informations du client</h5>
                    <div class="info-block">
                        <i class="fa fa-user-o" aria-hidden="true"></i>
                        <p>{{this.ficheClientInfos.lastname}} {{this.ficheClientInfos.firstname}}</p>
                    </div>
                    <div class="info-block">
                        <i class="fa fa-envelope-o" aria-hidden="true"></i>
                        <p>{{this.ficheClientInfos.email}}</p>
                    </div>
                    <div class="info-block" *ngIf="this.ficheClientInfos.phone">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <p>{{this.ficheClientInfos.phone}}</p>
                    </div>
                    <div class="info-block">
                        <i class="fa fa-user" aria-hidden="true"></i>
                        <p>Inscription le <span class="text-bold">{{this.ficheClientInfos.created_at |
                                date:'longDate'}}</span>
                        </p>
                    </div>
                    <div class="info-block" *ngIf="this.ficheClientInfos.updated_at">
                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                        <p>Modifié le <span class="text-bold">{{this.ficheClientInfos.updated_at |
                                date:'longDate'}}</span></p>
                    </div>
                </div>
                <!-- Info connection of account -->

            </div>
        </div>
    </div>
</div>